<template>
  <modal>
    <div class="modal-header">
      <h4 class="title">นำเข้าวิดีโอ</h4>
      <button
        @click.stop="onClose"
        type="button"
        class="btn btn-link btm-sm btn-close-container">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <!-- <form> -->
      <div class="modal-body">
        <FormGroup class="mb-0">
          <h5 class="name">เลือกวิดีโอ</h5>
          <input class="form-control" :placeholder="'ค้นหาวิดีโอ'" v-model="filter.q" @keyup.enter="onSearchVideos"/>
          <div class="wrapper-container">
            <div class="video-list-container" v-if="hasVideoOption && !isLoading">
              <div class="video-item"
                v-for="(video, index) in videos"
                :key="index"
                @click="onSelectVideo(video.id)">
                <div class="video-image">
                  <ImageView
                    :source="video.coverImage"
                    :imageSize="'cover160w90h'" />
                </div>
                <div class="video-title">{{video.title}}</div>
                <div class="checkbox-container">
                  <input
                    type="checkbox"
                    class="styled-checkbox"
                  />
                  <span class="checkmark" :class="{ checked: hasVideo(video.id)}">
                    <i class="fa fa-check check-icon" />
                  </span>
                </div>
              </div>
            </div>
            <div class="empty-state-container center-container" v-if="!hasVideoOption && !isLoading">
              <div class="no-video empty-state">
                ไม่พบวิดีโอที่ค้นหา
              </div>
            </div>
            <div class="spinner-container center-container" v-if="isLoading">
              <i class="fa fa-spinner fa-3x fa-spin"/>
            </div>
          </div>
          <div class="pagination-container">
            <PaginationModal
              :lastPage="lastPage"
              :currentPage.sync="filter.page"
              v-if="isShowPagination"
            />
          </div>
        </FormGroup>
      </div>
      <div class="modal-footer">
       <div class="error-text" v-if="errorCode && !errorVideoTitle">บันทึกไม่สำเร็จกรุณาติดต่อผู้ดูแลระบบ (code: {{errorCode}})</div>
       <div class="error-text" v-if="errorVideoTitle">มีวิดีโอ "{{errorVideoTitle}}" อยู่ในระบบแล้ว</div>
        <button
          class="btn btn-primary"
          type="button"
          @click="onSubmit"
          :disabled="!isValid">
          <i class="fa fa-spinner fa-spin mr-1" v-if="isSaving"/>นำเข้า
          <span v-if="videoCount"> {{videoCount}} วิดีโอ</span>
        </button>
      </div>
    <!-- </form> -->
  </modal>
</template>

<script>
import _ from 'lodash';
import Modal from '@/components/Modal.vue';
import FormGroup from '@/components/FormGroup.vue';
import PaginationModal from '@/components/PaginationModal.vue';
import ImageView from '@/image/ImageView.vue';

import { loadTpbsVideos, importVideos } from './api';

export default {
  components: {
    Modal,
    FormGroup,
    PaginationModal,
    ImageView,
  },
  data() {
    return {
      programs: [],
      selectedProgram: null,
      videos: [],
      selectedVideos: [],
      lastPage: 1,
      errorCode: null,
      errorVideoTitle: null,
      isSaving: false,
      isLoading: false,
      filter: {
        q: '',
        page: 1,
      },
    };
  },
  created() {
    this.loadVideos();
  },
  computed: {
    isShowPagination() {
      return this.lastPage > 1;
    },
    page() {
      return this.filter.page;
    },
    hasVideoOption() {
      return this.videos && this.videos.length > 0;
    },
    isValid() {
      if (this.errorCode || this.errorVideoTitle) {
        return false;
      }
      if (this.selectedVideos && this.selectedVideos.length === 0) {
        return false;
      }
      return true;
    },
    videoCount() {
      return this.selectedVideos.length;
    },
  },
  watch: {
    page(newPage) {
      const filter = {
        ...this.filter,
        page: newPage,
      };
      this.loadVideos(filter);
    },
  },
  methods: {
    async loadVideos(filter) {
      this.isLoading = true;
      const response = await loadTpbsVideos(filter);
      this.videos = response.data.data;
      this.lastPage = response.data.last_page;
      this.isLoading = false;
    },
    onSearchVideos() {
      this.filter.page = 1;
      this.loadVideos(this.filter);
    },
    hasVideo(videoId) {
      const index = this.selectedVideos.indexOf(videoId);
      if (index > -1) {
        return true;
      }
      return false;
    },
    onSelectVideo(videoId) {
      this.errorCode = null;
      this.errorVideoTitle = null;
      if (this.hasVideo(videoId)) {
        const index = this.selectedVideos.indexOf(videoId);
        if (index >= 0) {
          this.selectedVideos.splice(index, 1);
        }
        return;
      }
      this.selectedVideos.push(videoId);
    },
    async onSubmit() {
      try {
        this.isSaving = true;
        await importVideos(this.selectedVideos);
        this.isSaving = false;
        this.onClose();
      } catch (error) {
        this.errorCode = error.response.status;
        this.errorVideoTitle = _.get(error, 'response.data.videoTitle', null);
        this.isSaving = false;
      }
    },
    onClose() {
      this.$router.push('/videos');
    },
    getCoverImage(video) {
      return _.get(video, 'coverImage.urls.cover160w90h', null);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';


.error-text {
  font-size: 80%;
  color: #dc3545;
  width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
}

.wrapper-container {
  height: 300px;
  border-bottom: 0.5px solid $gray-200;
  border-left: 0.5px solid $gray-200;
  border-right: 0.5px solid $gray-200;
  overflow: auto;

  .video-item {
    display: flex;
    align-items: center;
    padding: 0.75 * $spacer $spacer;
    cursor: pointer;
    .video-image {
      width: 25%;
    }
    .video-title {
      width: 60%;
      padding-left: $spacer;
    }
    .checkbox-container {
      margin-left: auto;
      position: relative;
      height: 30px;
      width: 30px;
      .styled-checkbox {
        position: relative;
        opacity: 0;
        height: 0;
        width: 0;
      }
      .checkmark {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 30px;
        width: 30px;
        top: 0;
        right: 0;
        border-radius: 30px;
        border: 2px solid $gray-300;
        .check-icon {
          display: none;
        }
      }
      .checked {
        transition: all 0.2s ease-in;
        border: 2px solid $success;
        color: $success;
        .check-icon {
          display: inline;
        }
      }
    }
  }
  .video-item:hover {
    transition: all 0.2s ease-in;
    background-color: $gray-100;
  }
  .center-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
  }
}

.pagination-container {
  margin-top: $spacer;
  // height: 40px;
}

@media (max-width: 575.98px) {
  .video-title {
    font-size: $font-size-base * 0.8;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

</style>
